function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/image/utils
 */
import { findOptimalInsertionPosition, isWidget, toWidget } from '@ckeditor/ckeditor5-widget/src/utils';
/**
 * Converts a given {@link module:engine/view/element~Element} to an image widget:
 * * Adds a {@link module:engine/view/element~Element#_setCustomProperty custom property} allowing to recognize the image widget element.
 * * Calls the {@link module:widget/utils~toWidget} function with the proper element's label creator.
 *
 * @param {module:engine/view/element~Element} viewElement
 * @param {module:engine/view/downcastwriter~DowncastWriter} writer An instance of the view writer.
 * @param {String} label The element's label. It will be concatenated with the image `alt` attribute if one is present.
 * @returns {module:engine/view/element~Element}
 */

export function toImageWidget(viewElement, writer, label) {
  writer.setCustomProperty('image', true, viewElement);
  return toWidget(viewElement, writer, {
    label: labelCreator
  });

  function labelCreator() {
    var imgElement = getViewImgFromWidget(viewElement);
    var altText = imgElement.getAttribute('alt');
    return altText ? "".concat(altText, " ").concat(label) : label;
  }
}
/**
 * Checks if a given view element is an image widget.
 *
 * @param {module:engine/view/element~Element} viewElement
 * @returns {Boolean}
 */

export function isImageWidget(viewElement) {
  return !!viewElement.getCustomProperty('image') && isWidget(viewElement);
}
/**
 * Returns an image widget editing view element if one is selected.
 *
 * @param {module:engine/view/selection~Selection|module:engine/view/documentselection~DocumentSelection} selection
 * @returns {module:engine/view/element~Element|null}
 */

export function getSelectedImageWidget(selection) {
  var viewElement = selection.getSelectedElement();

  if (viewElement && isImageWidget(viewElement)) {
    return viewElement;
  }

  return null;
}
/**
 * Checks if the provided model element is an `image`.
 *
 * @param {module:engine/model/element~Element} modelElement
 * @returns {Boolean}
 */

export function isImage(modelElement) {
  return !!modelElement && modelElement.is('element', 'image');
}
/**
 * Handles inserting single file. This method unifies image insertion using {@link module:widget/utils~findOptimalInsertionPosition} method.
 *
 *		insertImage( model, { src: 'path/to/image.jpg' } );
 *
 * @param {module:engine/model/model~Model} model
 * @param {Object} [attributes={}] Attributes of inserted image
 * @param {module:engine/model/position~Position} [insertPosition] Position to insert the image. If not specified,
 * the {@link module:widget/utils~findOptimalInsertionPosition} logic will be applied.
 */

export function insertImage(model) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var insertPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  model.change(function (writer) {
    var imageElement = writer.createElement('image', attributes);
    var insertAtSelection = insertPosition || findOptimalInsertionPosition(model.document.selection, model);
    model.insertContent(imageElement, insertAtSelection); // Inserting an image might've failed due to schema regulations.

    if (imageElement.parent) {
      writer.setSelection(imageElement, 'on');
    }
  });
}
/**
 * Checks if image can be inserted at current model selection.
 *
 * @param {module:engine/model/model~Model} model
 * @returns {Boolean}
 */

export function isImageAllowed(model) {
  var schema = model.schema;
  var selection = model.document.selection;
  return isImageAllowedInParent(selection, schema, model) && !checkSelectionOnObject(selection, schema) && isInOtherImage(selection);
}
/**
 * Get view `<img>` element from the view widget (`<figure>`).
 *
 * Assuming that image is always a first child of a widget (ie. `figureView.getChild( 0 )`) is unsafe as other features might
 * inject their own elements to the widget.
 *
 * The `<img>` can be wrapped to other elements, e.g. `<a>`. Nested check required.
 *
 * @param {module:engine/view/element~Element} figureView
 * @returns {module:engine/view/element~Element}
 */

export function getViewImgFromWidget(figureView) {
  var figureChildren = [];

  var _iterator = _createForOfIteratorHelper(figureView.getChildren()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var figureChild = _step.value;
      figureChildren.push(figureChild);

      if (figureChild.is('element')) {
        figureChildren.push.apply(figureChildren, _toConsumableArray(figureChild.getChildren()));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return figureChildren.find(function (viewChild) {
    return viewChild.is('element', 'img');
  });
} // Checks if image is allowed by schema in optimal insertion parent.
//
// @returns {Boolean}

function isImageAllowedInParent(selection, schema, model) {
  var parent = getInsertImageParent(selection, model);
  return schema.checkChild(parent, 'image');
} // Check if selection is on object.
//
// @returns {Boolean}


function checkSelectionOnObject(selection, schema) {
  var selectedElement = selection.getSelectedElement();
  return selectedElement && schema.isObject(selectedElement);
} // Checks if selection is placed in other image (ie. in caption).


function isInOtherImage(selection) {
  return _toConsumableArray(selection.focus.getAncestors()).every(function (ancestor) {
    return !ancestor.is('element', 'image');
  });
} // Returns a node that will be used to insert image with `model.insertContent` to check if image can be placed there.


function getInsertImageParent(selection, model) {
  var insertAt = findOptimalInsertionPosition(selection, model);
  var parent = insertAt.parent;

  if (parent.isEmpty && !parent.is('element', '$root')) {
    return parent.parent;
  }

  return parent;
}